import { CSSProperties } from 'react';
import { WrappedFieldInputProps } from 'redux-form';
import {
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  ClassNameMap,
} from '@mui/material';

type SelectInputProps = {
  label: string;
  input: WrappedFieldInputProps;
  meta: {
    touched: boolean;
    error: boolean;
  };
  options: Array<{ [key: string]: any }> | Array<string>;
  classes?: ClassNameMap;
  valueKey?: string;
  labelKey?: string;
  style?: CSSProperties;
  required?: boolean;
};

const SelectInput = ({
  input,
  label,
  meta,
  options,
  style,
  required,
  ...custom
}: SelectInputProps) => {
  const { classes, valueKey, labelKey } = custom;
  const { touched, error } = meta;

  return (
    <FormControl
      classes={classes}
      error={touched && error}
      variant="filled"
      style={style}
    >
      <InputLabel>
        {label}
        {required ? '*' : ''}
      </InputLabel>
      <Select {...input} inputProps={{ name: input.name }}>
        <MenuItem value="">-</MenuItem>
        {options.map((item: any, index: number) => {
          return (
            <MenuItem value={valueKey ? item[valueKey] : item} key={index}>
              {labelKey ? item[labelKey] : item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectInput;
